import React from 'react';
import {
	ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT,
	EntryKeys,
} from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { FeedbackCollectorButton } from '@atlassian/jira-feedback-collector/src/ui/button/index.tsx';
import { useProjectContext } from '../../../services/get-project/index.tsx';

const FEEDBACK_COLLECTOR_LOCATION = 'releases.version.detail';

export const FeedbackButton = () => {
	const { simplified, isProjectAdmin } = useProjectContext();

	const additionalFeedbackEntries = [
		{
			id: EntryKeys.FEEDBACK_COLLECTOR_LOCATION,
			value: FEEDBACK_COLLECTOR_LOCATION,
		},
		{
			id: EntryKeys.IS_SIMPLIFIED_PROJECT,
			value: simplified.toString(),
		},
		{
			id: EntryKeys.IS_ADMIN,
			value: isProjectAdmin == null ? 'unknown' : isProjectAdmin.toString(),
		},
	];

	return (
		<FeedbackCollectorButton
			entrypointId={ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT}
			feedbackContext={additionalFeedbackEntries}
		/>
	);
};
